export function toSnakeCase(str: string): string {
    return str
        // Replace spaces and hyphens with underscores
        .replace(/[\s-]+/g, '_')
        // Insert underscore before uppercase letters (except at the start)
        .replace(/([a-z])([A-Z])/g, '$1_$2')
        // Convert everything to lowercase
        .toLowerCase();
}

/**
 * Converts a snake_case string to Title Case.
 * Example: "this_is_a_test" -> "This Is A Test"
 */
export function snakeToTitleCase(str: string): string {
    return str
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}
